// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as ReactLeaflet from "react-leaflet";
import * as OrderMarkersMapper from "../../../view-mappers/OrderMarkersMapper.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";

import './LeafletPopup.css'
;

function s(prim) {
  return prim;
}

function LeafletPopup(Props) {
  var title = Props.title;
  var address = Props.address;
  var time_stamp = Props.time_stamp;
  var containerClass = address === "" ? "popup-container popup-container-empty" : "popup-container";
  var time_stamp$1 = time_stamp !== undefined ? Caml_option.valFromOption(time_stamp) : Timestamp$Catalyst.make(0.0);
  return React.createElement(ReactLeaflet.Popup, {
              children: React.createElement("div", {
                    className: containerClass
                  }, React.createElement("div", {
                        className: "popup-header"
                      }, React.createElement("div", {
                            className: "popup-header-left"
                          }), React.createElement("div", {
                            className: "popup-header-right"
                          })), React.createElement("div", {
                        className: "popup-title"
                      }, title), React.createElement("div", {
                        className: "popup-date"
                      }, OrderMarkersMapper.getTsString(time_stamp$1)), React.createElement("div", {
                        className: "popup-address"
                      }, address)),
              closeButton: true
            });
}

var make = LeafletPopup;

export {
  s ,
  make ,
  
}
/*  Not a pure module */
